module.exports = "/_next/static/images/bec0b3ede59c1b8b2736d95711fc73c1-payment_final.png.webp";